import { render, staticRenderFns } from "./authLoginCommercialHelp.vue?vue&type=template&id=0bf26d62&scoped=true"
import script from "./authLoginCommercialHelp.vue?vue&type=script&lang=js"
export * from "./authLoginCommercialHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf26d62",
  null
  
)

export default component.exports